import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

const Layout = ({ children, hideOn = [], hideWhenPathIncludes = [] }) => {
  const location = useLocation();

  if (
    hideOn.includes(location.pathname) ||
    hideWhenPathIncludes.some((path) => location.pathname.includes(path))
  ) {
    return null;
  }

  return (
    <div className="w-full fixed top-0 left-0 z-50 bg-white">
      {children}
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  hideOn: PropTypes.arrayOf(PropTypes.string),
  hideWhenPathIncludes: PropTypes.arrayOf(PropTypes.string),
};

export default Layout;
